import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { LocalStorageService } from '../core/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class DarkmodeService {
  private darkModeToogle;
  constructor(private localStorageService: LocalStorageService) {
    const deviceMode = window.matchMedia('(prefers-color-scheme: dark)');
    const isDarkMode = this.localStorageService.get('darkMode');

    if (typeof isDarkMode === 'boolean') {
      this.darkModeToogle = new BehaviorSubject(isDarkMode);
    } else {
      if (deviceMode.matches) {
        this.darkModeToogle = new BehaviorSubject(true);
      } else {
        this.darkModeToogle = new BehaviorSubject(false);
      }
    }
  }
  getDarkMode() {
    return this.darkModeToogle.asObservable();
  }
  updateDarkMode(state: boolean) {
    this.localStorageService.set('darkMode', state);
    this.darkModeToogle.next(state);
  }
  // Set the theme for the current view only, without persisting to localStorage.
  // Used by the public shared-audit page so it follows the sharer's theme
  // instead of overwriting the viewer's own saved preference.
  setDarkModeTransient(state: boolean) {
    this.darkModeToogle.next(state);
  }
}
